var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D73735;}\r\n\t.st1{fill:#F85252;}\r\n\t.st2{fill:#EDAF85;}\r\n\t.st3{fill:#F7C09A;}\r\n\t.st4{fill:#D8D6D7;}\r\n\t.st5{fill:#FFFFFF;}\r\n\t.st6{fill:#1C868E;}\r\n\t.st7{fill:#40C4DF;}\r\n\t.st8{fill:#491352;}\r\n\t.st9{fill:#56C1B3;}\r\n\t.st10{fill:#7BEFE4;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.5,235.439H9.5c-2.761,0-5-2.239-5-5V25.561c0-2.761,2.239-5,5-5h237c2.761,0,5,2.239,5,5v204.879 C251.5,233.201,249.261,235.439,246.5,235.439z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M251.5,55.74v174.7c0,2.76-2.24,5-5,5H9.5c-2.76,0-5-2.24-5-5V25.56c0-2.76,2.24-5,5-5h59.95l25.51,31.7 c1.77,2.2,4.45,3.48,7.28,3.48H251.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M251.5,55.74v174.7c0,2.761-2.239,5-5,5H24.73c-2.761,0-5-2.239-5-5V25.56c0-2.761,2.239-5,5-5h44.72 l25.51,31.7c1.77,2.2,4.45,3.48,7.28,3.48H251.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 205.342,
    cy: 38.457,
    r: 6.896
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 230.584,
    cy: 38.457,
    r: 6.896
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M236.41,85.17v121.66c0,5.52-4.48,10-10,10H29.59c-5.52,0-10-4.48-10-10V85.17c0-5.52,4.48-10,10-10h196.82 C231.93,75.17,236.41,79.65,236.41,85.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M236.41,196v10.83c0,5.52-4.48,10-10,10H29.59c-5.52,0-10-4.48-10-10V196H236.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M84,186.5H34.667c-2.761,0-5-2.239-5-5v-91c0-2.761,2.239-5,5-5H84c2.761,0,5,2.239,5,5v91 C89,184.261,86.761,186.5,84,186.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M220.25,185.25h-113.5c-2.761,0-5-2.239-5-5V90.5c0-2.761,2.239-5,5-5h113.5c2.761,0,5,2.239,5,5v89.75 C225.25,183.011,223.011,185.25,220.25,185.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.97,135.47c-53.428,0-97.067,41.913-99.831,94.653c-0.151,2.882,2.106,5.317,4.992,5.317h189.678 c2.886,0,5.143-2.435,4.992-5.317C242.037,177.383,198.398,135.47,144.97,135.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M221.27,220.71H68.67c-4.08,0-6.99-3.89-5.91-7.82c9.91-36.09,43.01-62.69,82.21-62.69 c3.13,0,6.22,0.17,9.27,0.5c35.07,3.81,63.82,28.98,72.94,62.19C228.26,216.82,225.35,220.71,221.27,220.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M221.27,220.71H87.2c-4.08,0-6.99-3.89-5.91-7.82c9.12-33.21,37.88-58.38,72.95-62.19 c35.07,3.81,63.82,28.98,72.94,62.19C228.26,216.82,225.35,220.71,221.27,220.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.423,211.19h-8.906v-27.07c0-2.459,1.994-4.453,4.453-4.453l0,0c2.459,0,4.453,1.994,4.453,4.453V211.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M164.21,220.71h-38.48c0.1-10.53,8.68-19.04,19.24-19.04C155.53,201.67,164.11,210.18,164.21,220.71z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M246.5,18.561c-9.417,0-227.386,0-236.781,0H9.5c-3.86,0-7,3.14-7,7v0.219v204.44v0.219c0,3.86,3.14,7,7,7 h0.219c12.94,0,223.455,0,236.781,0c3.859,0,7-3.14,7-7v-0.219c0-5.747,0-180.829,0-204.66 C253.5,21.701,250.359,18.561,246.5,18.561z M45.094,214.83H29.59c-4.411,0-8-3.589-8-8V198h28.53 c-0.807,2.037-1.544,4.109-2.221,6.208H32.25c-1.104,0-2,0.896-2,2s0.896,2,2,2h14.448 C46.093,210.387,45.555,212.594,45.094,214.83z M220.25,83.5h-113.5c-3.86,0-7,3.14-7,7v53.563 c-3.003,1.492-5.923,3.128-8.75,4.899V90.5c0-3.86-3.14-7-7-7H34.67c-3.86,0-7,3.14-7,7v91c0,3.86,3.14,7,7,7h19.797 c-0.939,1.803-1.826,3.636-2.658,5.5H21.59V85.17c0-4.411,3.589-8,8-8h196.82c4.411,0,8,3.589,8,8v101.34 c-2.145-3.905-4.54-7.653-7.16-11.227V90.5C227.25,86.64,224.109,83.5,220.25,83.5z M223.25,90.5v79.671 c-29.562-35.396-78.41-46.222-119.5-27.989V90.5c0-1.654,1.346-3,3-3h113.5C221.904,87.5,223.25,88.846,223.25,90.5z M45,174 h18.643c-2.534,3.346-4.869,6.851-6.982,10.5H34.67c-1.654,0-3-1.346-3-3v-91c0-1.654,1.346-3,3-3H84c1.654,0,3,1.346,3,3v61.1 c-7.516,5.213-14.3,11.408-20.166,18.4H45c-1.104,0-2,0.896-2,2S43.896,174,45,174z M47.02,233.439 c1.07-53.1,44.598-95.97,97.95-95.97s96.879,42.87,97.949,95.97H47.02z M249.5,230.22c0,1.558-1.114,2.86-2.587,3.155 c-0.274-13.746-3.284-26.832-8.503-38.738V85.17c0-6.617-5.383-12-12-12H29.59c-6.617,0-12,5.383-12,12 c0,5.851,0,117.092,0,121.66c0,6.617,5.383,12,12,12h14.77c-0.784,4.768-1.239,9.645-1.335,14.609H9.719 c-1.775,0-3.219-1.444-3.219-3.219V25.78c0-1.775,1.444-3.219,3.219-3.219h58.773L93.404,53.51 c2.163,2.688,5.382,4.229,8.832,4.229H249.5V230.22z M249.5,53.739H102.235c-2.232,0-4.315-0.998-5.715-2.737L73.627,22.561H246.5 c1.654,0,3,1.346,3,3V53.739z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M58.76,37.618H24.217c-1.104,0-2,0.896-2,2s0.896,2,2,2H58.76c1.104,0,2-0.896,2-2 S59.864,37.618,58.76,37.618z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M205.343,29.561c-4.905,0-8.896,3.991-8.896,8.896c0,4.905,3.991,8.896,8.896,8.896 c4.905,0,8.896-3.991,8.896-8.896C214.239,33.552,210.248,29.561,205.343,29.561z M205.343,43.354c-2.7,0-4.896-2.196-4.896-4.896 s2.196-4.896,4.896-4.896s4.896,2.197,4.896,4.896S208.043,43.354,205.343,43.354z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M230.584,29.561c-4.905,0-8.896,3.991-8.896,8.896c0,4.905,3.99,8.896,8.896,8.896s8.896-3.991,8.896-8.896 C239.48,33.552,235.489,29.561,230.584,29.561z M230.584,43.354c-2.699,0-4.896-2.196-4.896-4.896s2.196-4.896,4.896-4.896 c2.7,0,4.896,2.197,4.896,4.896S233.284,43.354,230.584,43.354z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M45,98.333h28.25c1.104,0,2-0.896,2-2s-0.896-2-2-2H45c-1.104,0-2,0.896-2,2S43.896,98.333,45,98.333z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M45,110.944h28.25c1.104,0,2-0.896,2-2s-0.896-2-2-2H45c-1.104,0-2,0.896-2,2S43.896,110.944,45,110.944z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M45,123.556h28.25c1.104,0,2-0.896,2-2s-0.896-2-2-2H45c-1.104,0-2,0.896-2,2S43.896,123.556,45,123.556z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M45,136.167h28.25c1.104,0,2-0.896,2-2s-0.896-2-2-2H45c-1.104,0-2,0.896-2,2S43.896,136.167,45,136.167z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M45,148.778h28.25c1.104,0,2-0.896,2-2s-0.896-2-2-2H45c-1.104,0-2,0.896-2,2S43.896,148.778,45,148.778z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M45,161.389h28.25c2.642,0,2.646-4,0-4H45c-1.104,0-2,0.896-2,2S43.896,161.389,45,161.389z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M152.232,98.333h58.018c2.642,0,2.646-4,0-4h-58.018C149.59,94.333,149.586,98.333,152.232,98.333z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M116.75,98.333h21.292c2.642,0,2.646-4,0-4H116.75c-1.104,0-2,0.896-2,2S115.646,98.333,116.75,98.333z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M210.25,104.666h-24.97c-2.642,0-2.646,4,0,4h24.97C212.892,108.666,212.896,104.666,210.25,104.666z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M170.991,108.666c2.642,0,2.646-4,0-4H116.75c-2.642,0-2.646,4,0,4H170.991z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M116.75,118.998h93.5c2.642,0,2.646-4,0-4h-93.5C114.108,114.998,114.104,118.998,116.75,118.998z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M210.25,125.331c-9.76,0-83.732,0-93.5,0c-2.642,0-2.646,4,0,4c9.746,0,83.746,0,93.5,0 C212.892,129.331,212.896,125.331,210.25,125.331z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M210.25,135.667h-17.93c-2.642,0-2.646,4,0,4h17.93c1.104,0,2-0.896,2-2S211.354,135.667,210.25,135.667z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M144.97,148.2c-39.167,0-73.765,26.384-84.139,64.16c-1.433,5.218,2.448,10.35,7.839,10.35h57.06h38.48h57.06 c5.388,0,9.273-5.128,7.839-10.35C218.735,174.584,184.136,148.2,144.97,148.2z M127.868,218.71 c1.083-8.458,8.369-15.04,17.102-15.04c8.733,0,16.02,6.582,17.103,15.04H127.868z M142.52,199.825V184.12 c0-3.235,4.9-3.246,4.9,0v15.705C145.653,199.619,144.293,199.618,142.52,199.825z M221.27,218.71h-55.179 c-0.877-8.473-6.792-15.493-14.671-18.024c0-17.766,0.56-18.654-1.895-21.139c-4.074-4.023-11.006-1.151-11.006,4.573v16.566 c-7.878,2.53-13.792,9.551-14.67,18.023c-59.612,0-56.72,0.659-58.457-1.62c-0.8-1.049-1.056-2.387-0.704-3.67 c9.897-36.045,42.911-61.22,80.281-61.22c37.371,0,70.384,25.174,80.281,61.22C225.985,216.092,224.018,218.71,221.27,218.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M142.97,161.375v10c0,2.643,4,2.646,4,0v-10C146.97,158.732,142.97,158.729,142.97,161.375z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M112.557,168.673c-1.321-2.289-4.787-0.292-3.464,2l5,8.66c1.323,2.293,4.785,0.288,3.464-2L112.557,168.673z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M94.33,194.914l-8.66-5c-2.296-1.326-4.285,2.145-2,3.464l8.66,5 C94.618,199.701,96.622,196.237,94.33,194.914z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M177.382,168.673l-5,8.66c-1.32,2.288,2.139,4.292,3.465,2l5-8.66 C182.167,168.384,178.706,166.381,177.382,168.673z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M196.611,198.646c0.853,0,0.748-0.125,9.658-5.269c2.292-1.323,0.285-4.79-2-3.464l-8.66,5 C193.84,195.935,194.576,198.646,196.611,198.646z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/시험.31cd95d98450e582b59d23bd74562e3d.svg";
export { ForwardRef as ReactComponent };